import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Typography, Box, useTheme } from '@mui/material'

import { fileActions } from '../../store/actions'
import { CustomLoadingOverlay, GenericContainer, GenericContainerCenter, Buttons } from '../../components'
import { coreFunctions,GenerateRandom } from '../../utils'
import image_hel_indexQRExternal from '../../assets/image_hel_indexQRExternal.jpg'
import { useTranslation } from 'react-i18next'

export default function IndexQRExternalComponent(props) {
    const navigate = useNavigate()
    const theme = useTheme()
    const [activaPeticion, setActivaPeticion] = useState(false)
    const [loadView, setLoadView] = useState(false)
    const valRandom = GenerateRandom();

    //Redux hooks
    const fileExt = useSelector(state => state.FolioExterno)

    const dispatch = useDispatch()
    const { t } = useTranslation();

    const generateUniqueId = () => {
        const newUniqueId = Math.floor(valRandom * 1000000);
        return newUniqueId.toString();
    };

    useEffect(() => {
        // console.log("fileExt:  ", fileExt)
        if (fileExt?.items != undefined && fileExt?.items != null
            && activaPeticion) {
            setActivaPeticion(false)

            let folioExternoData = fileExt.items?.Autientication
            sessionStorage.setItem(//Almacenar token opcion 1: SessionStorage
                'token',
                folioExternoData.Token
            )
            sessionStorage.setItem(
              //Borrar al cerrar sesión
              "userName",
              `${folioExternoData.UserLoginData.Name} ${
                folioExternoData.UserLoginData.FatherLastName ||
                folioExternoData.UserLoginData.MotherLastName
              }`
            );

            let fileData = fileExt.items?.FileData
            let stageName = fileData.Stage.Name
            let stageId = fileData.Stage.Id
            let stage = fileData.Stage
            let folioId = fileData.Id
            let nextComponent = coreFunctions.GetLegoNext(stageName)
            console.log("nextComponent: ", nextComponent)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
        } else if (fileExt?.error != undefined && fileExt?.error != null
            && activaPeticion) {
            // alert(fileExt?.error)
        }
    }, [fileExt])


    //Comienza interfaz
    return (<GenericContainer>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <GenericContainerCenter dynamicSize={220}>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h6" gutterBottom style={{ color: theme.palette.primary.main, fontWeight: 600, fontSize: '20px', lineHeight: '32px' }} >¡Qué gusto tenerte aquí!</Typography>
            </Box>
            <Box sx={{
                width: '100%', display: 'flex',
                justifyContent: 'center',
                height: '60vh', padding: '1em',
                overflow: 'hidden', alignContent: 'center', alignItems: 'center'
            }}>
                <img src={image_hel_indexQRExternal} style={{ height: '40vh' }} />
            </Box>
        </GenericContainerCenter>
        <Buttons ConfirmButtonText="Registrarme" onClickConfirm={() => {
            dispatch(fileActions.GenerateFolioExterno({
                ExternalIdentifier: generateUniqueId(),
                TieneInvitadosDummy: false,
            }))
            setActivaPeticion(true)
            setLoadView(true)
        }} />
    </GenericContainer>)
}
